import React from 'react';
import IconPremiumDelivery from 'components/icons/iconPremiumDelivery';

const PremiumDeliveryIcon = ({ color }) => (
  <IconPremiumDelivery width="34" height="34" color={color} />
);

export default PremiumDeliveryIcon;
